import { GlobalStyles } from 'twin.macro'

// https://github.com/ben-rogerson/twin.macro/issues/277#issuecomment-751418515
export default function CSSReset() {
  return <GlobalStyles />
}
